export default __webpack_public_path__ + "static/vpc-logo-8b77444336a37ff5cbb2ddf7f7108167.png";